<template>
    <div class="pl-3 container">
        <!-- Nome e Ícone de Usuário -->
        <div class="d-flex align-center mb-2 flex-wrap customer-name__text ml-n1 mt-n2">
            <span class="font-weight-normal color--primary">
                <v-icon color="primary" size="30" left class="mr-2 mt-n1">mdi-account</v-icon>{{ nome }}
            </span>
        </div>

        <!-- Documento -->
        <div class="d-flex align-center mb-2 flex-wrap">
            <v-icon color="black" size="18" left class="mr-2">mdi-card-account-details</v-icon>
            <span class="text--advice_friendly customer-info__label-text mr-1">{{ tipoDocumento }} </span>
            <span class="customer-info__value-text"> {{ documento || '-' }}</span>
        </div>

        <!-- Proposta -->
        <div class="d-flex align-center mb-2 flex-wrap" v-if="!(quantidadeCotas >1)">
            <v-icon color="black" size="18" left class="mr-2">mdi-file-document</v-icon>
            <span class="text--advice_friendly customer-info__label-text mr-1">Proposta: </span>
            <span class="customer-info__value-text">{{ proposta }}</span>
        </div>
        <div class="d-flex align-center mb-2 flex-wrap" v-if="!(quantidadeCotas >1) && idReserva">
            <v-icon color="black" size="18" left class="mr-2">mdi-file-lock</v-icon>
            <span class="text--advice_friendly customer-info__label-text mr-1">Reserva: </span>
            <span class="customer-info__value-text">{{ idReserva }}</span>
        </div>
        <div class="d-flex align-center mb-2 flex-wrap" v-if="multiplasReservas">
            <v-icon color="black" size="18" left class="mr-2">mdi-file-lock</v-icon>
            <span class="text--advice_friendly customer-info__label-text mr-1">{{ 'Múltiplas reservas' }}</span>
        </div>
        <div class="d-flex align-center mb-2 flex-wrap" v-if="quantidadeCotas >1">
            <v-tooltip top color="white" class="pl-4">
                <template v-slot:activator="{ on, attrs }">
                    <span style="cursor: pointer;" v-bind="attrs" v-on="on">
                        <v-icon color="black" size="18" left class="mr-2">mdi-file-multiple</v-icon>
                        <span class="text--advice_friendly customer-info__label-text mr-1">Múltiplas Cotas: </span>
                        <span class="customer-info__value-text">{{ quantidadeCotas }}</span>
                    </span>
                </template>
                <div style="color:var(--primary);font-weight: 700;">
                    ID Carrinho: {{ idCarrinho }}
                </div>
            </v-tooltip>
        </div>

        <!-- Data da Venda -->
        <div class="d-flex align-center mb-2 flex-wrap">
            <v-icon color="black" size="18" left class="mr-2">mdi-calendar-month</v-icon>
            <span class="text--advice_friendly customer-info__label-text mr-1">Início: </span>
            <span class="customer-info__value-text">{{ dataVenda | toDateTimeBR }}</span>
        </div>
        <div class="d-flex align-center mb-2 flex-wrap" v-if="dataFinal">
            <v-icon color="black" size="18" left class="mr-2">mdi-calendar-month</v-icon>
            <span class="text--advice_friendly customer-info__label-text mr-1">Fim: </span>
            <span class="customer-info__value-text">{{ dataFinal | toDateTimeBRSemHoraVazia }}</span>
        </div>
        <div class="d-flex align-center mb-2 flex-wrap" v-if="cdSimulacao">
           <v-icon color="black" size="18" left class="mr-2">mdi-file</v-icon>
           <span class="text--advice_friendly customer-info__label-text mr-1">Cód. Simulação: </span>
           <span class="customer-info__value-text">{{ cdSimulacao }}</span>
        </div>
        <div class="d-flex align-center mb-2 flex-wrap">
            <v-icon color="black" size="18" left class="mr-2">{{ tipoGrupoIcon }}</v-icon>
            <span class="customer-info__value-text">{{ tipoGrupo }}</span>
        </div>

        <!-- Imagem -->
        <div class="mt-3 text-center">
            <v-img
                    v-if="nomeFlavor"
                    :src='"@/assets/flavors/" + trazerNomeFlavor() + "/img/logo-menu.png"'
                    alt="Imagem da Empresa"
                    class="empresa-imagem"
                    contain
                    height="auto"
            ></v-img>
        </div>

        <!-- Nome da Empresa -->
        <div class="text-center nome-empresa">
            <span class="text--darkgray">{{ nomeEmpresa }}</span>
        </div>
    </div>
</template>
<script>
  export default {
    name: 'PropostaInfoColumn',
    props: {
      nome: {
        type: String,
        required: true
      },
      documento: {
        type: String,
        required: true
      },
      proposta: {
        type: String,
        required: true
      },
      dataVenda: {
        type: String,
        required: true
      },
      nomeFlavor: {
        type: String,
        required: true
      },
      nomeEmpresa: {
        type: String,
        required: true
      },
      tipoDocumento: {
        type: String,
        required: true
      },
      tipoGrupoIcon: {
        type: String,
        required: true
      },
      tipoGrupo: {
        type: String,
        required: true
      },
      quantidadeCotas: {
        type: Number,
        required: false
      },
      idReserva: {
        type: Number,
        required: false
      },
      multiplasReservas: {
        type: Boolean,
        required: false
      },
      idCarrinho: {
        type: [Number, String],
        required: false
      },
      dataFinal: {
        type: String,
        required: false
      },
      cdSimulacao: {
        type: [Number, String],
        required: false
      }
    },
    methods: {
      trazerNomeFlavor () {
        return this.nomeFlavor
      }
    }
  }
</script>
<style scoped>
.color--primary {
  color: var(--primary);
}
.empresa-imagem {
  max-width: 100%;
  width: 300px;
  height: auto;
  margin: 0 auto;
}
.customer-name__text {
  font-size: 1.6rem;
  font-weight: 700;
}
.customer-info__label-text {
  font-size: 1.3rem;
}
.customer-info__value-text {
  font-size: 1.3rem;
  font-weight: 700;
}
.nome-empresa {
  font-size: 1rem; /* Aumenta o tamanho da fonte */
  font-weight: bold; /* Torna o texto mais proeminente */
  text-transform: uppercase;

}
</style>
